import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';

import FeedbackModalWrapper from './components/FeedbackModalWrapper';

import { submitFeedback } from './ducks';

import { Gap } from '~ui-kit';

import { primaryColor } from '~theme';

import headerIcon from '~images/request_permissions.svg';

const RequestPermissionsModal = props => {
  const [message, setMessage] = useState('');
  const [unit, setUnit] = useState(null);

  const dispatch = useDispatch();

  const show = useSelector(state => state.modals.show);
  const units = useSelector(state => state.reducer.organizations);

  useEffect(() => {
    // Reset state when hidden
    if (!show) {
      setMessage('');
      setUnit(null);
    }
  }, [show]);

  const handleSubmit = () => {
    dispatch(
      submitFeedback({
        message,
        type: 'MESSAGE_ACCESS_PERMISSIONS',
        unit: unit?.value,
      })
    );
  };

  const unitOptions = units.map(unit => ({
    value: unit.id.toString(),
    // label: `${unit.name}${
    //   unit.costCentreCode ? ` ${unit.costCentreCode}` : ''
    // }`,
    label: unit.name,
  }));

  return (
    <FeedbackModalWrapper
      name="REQUEST_PERMISSIONS"
      title="Pyydä oikeus yksikköön"
      confirmOnClick={handleSubmit}
      confirmDisabled={!unit && !message}
      headerLargeIcon={headerIcon}
    >
      <Wrapper>
        <OrderDetails>
          Palvelukoordinaattorimme reagoi viestiisi pikimmiten.
        </OrderDetails>

        <Gap height="24px" />

        <Label>Yksikkö, jolle haluat luvan</Label>
        <Select
          placeholder="Valitse, jos tiedät yksikön nimen"
          value={unit}
          options={unitOptions}
          onChange={v => setUnit(v)}
          isClearable
        />

        <Gap height="24px" />

        <Label>Kommenttisi</Label>
        <TextArea
          className="form-control"
          maxLength="2000"
          rows={5}
          placeholder="Tarvittaessa esim. lisätietoja"
          value={message}
          onChange={event => setMessage(event.target.value)}
        />

        <Gap height="50px" />
      </Wrapper>
    </FeedbackModalWrapper>
  );
};

const Wrapper = styled.div`
  color: ${primaryColor};
`;

const OrderDetails = styled.div`
  font-size: 16px;
`;

const Label = styled.label`
  font-size: 16px;
  margin-bottom: 12px;
`;

const TextArea = styled.textarea`
  display: block;
  resize: none;
`;

export default RequestPermissionsModal;
